// extracted by mini-css-extract-plugin
export default {"control":"LangSwitcher_control__Qb6K1"};